<template>
  <div class="Review">
    <div v-if="notification !== null">
        <div class="notification" v-bind:class="{ error: notification.type === 'error', success: notification.type === 'success' }">
            <span v-on:click="clearNotification">x</span>
            {{notification.message}}
        </div>
    </div>
    <div class="container">
        <div class="float-right lang-selector">
            <a v-bind:class="{ active: curLang === 'FR' }" v-on:click="changelang('FR')">🇫🇷</a>
            <a v-bind:class="{ active: curLang === 'EN' }" v-on:click="changelang('EN')">🇬🇧</a>
            <a v-bind:class="{ active: curLang === 'DE' }" v-on:click="changelang('DE')">🇩🇪</a>
            <a v-bind:class="{ active: curLang === 'IT' }" v-on:click="changelang('IT')">🇮🇹</a>
            <a v-bind:class="{ active: curLang === 'ES' }" v-on:click="changelang('ES')">🇪🇸</a>
        </div>
        <h1 id="questionnaire-main-header">{{lang.title_trade_in_summary}}</h1>
        <div v-if="questionnaire !== null">
            <table aria-describedby="questionnaire-main-header">
                <tbody>
                    <tr>
                        <td>{{lang.title_created_at}}</td>
                        <td>{{questionnaire.created_at}}</td>
                    </tr>
                    <tr>
                        <td>{{lang.title_expires_at}}</td>
                        <td>{{questionnaire.expires_at}}</td>
                    </tr>
                    <tr>
                        <td>{{lang.title_value}}</td>
                        <td>{{questionnaire.reference}}</td>
                    </tr>
                    <tr>
                        <td>{{lang.title_original_value}}</td>
                        <td>{{questionnaire.currency_symbol}}{{questionnaire.original_value}}</td>
                    </tr>
                    <tr>
                        <td>{{lang.title_inspected_value}}</td>
                        <td>{{questionnaire.currency_symbol}}{{questionnaire.inspected_value}}</td>
                    </tr>
                    <tr>
                        <td>{{lang.title_status}}</td>
                        <td>{{questionnaire.status}}</td>
                    </tr>
                    <tr v-if="questionnaire.decided_at !== null">
                        <td>{{lang.title_decision_made_at}}</td>
                        <td>{{questionnaire.decided_at}}</td>
                    </tr>
                </tbody>
            </table>

            <h2 id="item-breakdown-header">{{lang.title_item_breakdown}}</h2>
            <table aria-describedby="item-breakdown-header">
                <thead>
                    <tr>
                        <th scope="column">{{lang.title_item_reference}}</th>
                        <th scope="column">{{lang.title_item_name}}</th>
                        <th scope="column">{{lang.title_downgrade_reason}}</th>
                        <th scope="column">{{lang.title_quoted_grade}}</th>
                        <th scope="column">{{lang.title_current_grade}}</th>
                        <th scope="column">{{lang.title_quoted_value}}</th>
                        <th scope="column">{{lang.title_current_value}}</th>
                    </tr>
                </thead>
                <tbody v-for="questionnaire_item in questionnaire.questionnaire_items" v-bind:key="questionnaire_item.item_reference">
                    <tr>
                        <td>{{questionnaire_item.item_reference}}</td>
                        <td>{{questionnaire_item.item_name}}</td>
                        <td>{{questionnaire_item.downgrade_reason}}</td>
                        <td>{{lang[`grade_${questionnaire_item.quoted_grade}`]}}</td>
                        <td>{{lang[`grade_${questionnaire_item.current_grade}`]}}</td>
                        <td>{{questionnaire.currency_symbol}}{{questionnaire_item.quoted_value}}</td>
                        <td>{{questionnaire.currency_symbol}}{{questionnaire_item.current_value}}</td>
                    </tr>
                </tbody>
            </table>

            <h2 v-if="questionnaire.status == 'Awaiting Decision'">{{lang.title_accept_reject_offer}}</h2>
            <div>
                <div v-if="questionnaire.status != lang.status_1">
                    <p>{{lang.text_decision_made}}</p>
                </div>
                <div v-else>
                    <p>{{lang.text_accept_reject}}</p>
                    <a class="button accept" v-on:click="accept">{{lang.button_accept}}</a>
                    <a class="button reject" v-on:click="reject">{{lang.button_reject}}</a>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
require('@/assets/css/primitive-ui.css')
import {EN, FR} from './lang.js';

function status(status, lang) {
  switch(status) {
        case 1: return lang.status_1; break;
        case 2: return lang.status_2; break;
        case 3: return lang.status_3; break;
        case 4: return lang.status_4; break;
    }
}
function dateFormat(dateString, lang) {
    var d = new Date(dateString);
    var month = lang[`month_${d.getMonth()+1}`];
    return `${d.getDate()} ${month}`;
}

function addSeconds(dateString, seconds) {
    return new Date(new Date(dateString).getTime() + (seconds * 1000)).toISOString()
}

var serviceLocation = this.$selfServiceLocation;
export default {
  name: 'Review',
  data () {
      return {
      questionnaire: null,
      notification: null,
      uuid: this.$route.params.uuid,
      lang: FR,
      curLang: 'FR',
      supportedLang: ['EN', 'FR', 'DE', 'IT', 'ES'],
      }
  },
  mounted () {
      if (navigator && navigator.language) {
          let lang = navigator.language;

          if (lang.indexOf('-') !== -1) {
             lang = lang.substring(0, lang.indexOf('-'))
          }

          lang = lang.toUpperCase()

          if (this.supportedLang.indexOf(lang) !== -1) {
              this.curLang = lang;
          }
      }
      this.loadLang(this.load);
  },
  methods: {
      load: function() {
        return axios
        .get(`${this.$selfServiceLocation}/questionnaire/${this.curLang}/${this.uuid}`)
        .then(response => {
            if (response.status !== 200) {
                if (response.status === 404) {
                    this.setNotification('error', `404 ${this.uuid}`);
                } else {
                    this.setNotification('error', `500 ${this.uuid}`);
                }
                return;
            }

            var questionnaire = response.data;
            questionnaire.status = status(questionnaire.status, this.lang);
            questionnaire.expires_at = dateFormat(addSeconds(questionnaire.created_at, (14*24*60*60)), this.lang);
            questionnaire.created_at = dateFormat(questionnaire.created_at, this.lang);

            if (questionnaire.decided_at != undefined) {
                questionnaire.decided_at = dateFormat(questionnaire.decided_at, this.lang);
            }

            this.questionnaire = questionnaire;
        })
        .catch(() => {
            this.setNotification('error', `${this.lang.error_500} ${this.uuid}`);
        })
      },
      loadLang: function(callback) {
        return axios
        .get(`${this.$selfServiceLocation}/translations/${this.curLang}`)
        .then(response => {
            if (response.status !== 200) {
                if (response.status === 404) {
                    this.setNotification('error', `error 404 ${this.uuid}`);
                } else {
                    this.setNotification('error', `error 500 ${this.uuid}`);
                }
                return;
            }

            this.lang = response.data;
            if (callback) {
                callback();
            }
        })
        .catch(() => {
            this.setNotification('error', `${this.lang.error_500} ${this.uuid}`);
        })
      },
      changelang: function(language) {
          this.curLang = language;
          this.loadLang(this.load);
      },
      FR: function() {
          this.curLang = 'FR';
          this.loadLang(this.load);
      },
      EN: function() {
        this.curLang = 'EN';
        this.loadLang(this.load);
      },
      DE: function() {
        this.curLang = 'DE';
        this.loadLang(this.load);
      },
      IT: function() {
        this.curLang = 'IT';
        this.loadLang(this.load);
      },
      ES: function() {
        this.curLang = 'ES';
        this.loadLang(this.load);
      },
      accept: function() { this.decide(2); },
      reject: function() { this.decide(3); },
      decide: function(s) {
          this.status = s;
          axios
          .put(`${this.$selfServiceLocation}/questionnaire/update`, {
              hash: this.uuid,
              status: s,
          })
          .then(() => {
            this.setNotification('success', `The status has been changed to ${status(this.status, this.lang)}`);
            this.questionnaire.status = status(this.status, this.lang);
          })
          .catch(() => {
              this.setNotification('error', `The status could not be changed to ${status(this.status, this.lang)}`);
          })
      },
      setNotification: function(t, m) {
          this.notification = { type: t, message: m };
      },
      clearNotification: function() {
          this.notification = null;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notification {
    margin:2px;
    padding: 5px 10px;
    border: 2px solid #000;
}
.notification span {
    float:right;
    font-weight:900;
}
.notification span:hover {
    cursor: pointer;
}
.notification.error {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
.notification.success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
a.button.accept {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
a.button.reject {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
.float-right {
    float:right;
}
.lang-selector a:hover {
    cursor: pointer;
}
.lang-selector a {
    border: 2px solid #fff;
    padding: 2px 3px;
}
.lang-selector a.active {
    border: 2px solid #999;
}
</style>



// WEBPACK FOOTER //
// Review.vue?71e532ab